import script from "./noticeList.vue?vue&type=script&setup=true&lang=ts"
export * from "./noticeList.vue?vue&type=script&setup=true&lang=ts"

import "./noticeList.vue?vue&type=style&index=0&id=4c25af2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c25af2a"]])

export default __exports__